import styled from "styled-components";

const ZeIncorrectText = styled.span`
  color: red;
`;

export default ZeIncorrectText;
